import { EntityBase } from './abstract-entity-base';
import { IMetadataEntity } from './interface-metadata-entity';

/**
 * åæ°æ®å®ä½æ½è±¡ç±»
 */
export abstract class MetadataEntityBase extends EntityBase implements IMetadataEntity{
    MetadataId: string;    
    
    AppCode: string;
    
    SuCode: string;
    
    BoId: string;

}